import style from "./ProfileDropdown.module.css";
import { useUser } from "@/features/auth/hooks/useUser";

import { Link, useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import Icon from "@/ui/icon/Icon";
import {
	DropdownMenu,
	DropdownMenuTrigger,
	DropdownMenuContent,
	DropdownMenuGroup,
	DropdownMenuItem,
} from "@/ui/dropdownMenu/DropdownMenu";

import { AUTH_TOKEN_LOCAL_STORAGE_ITEM_NAME } from "@/utils/constants";

function ProfileDropdown() {
	const { t } = useTranslation();
	const { user } = useUser();
	const queryClient = useQueryClient();
	const navigate = useNavigate();

	function logOut() {
		localStorage.removeItem(AUTH_TOKEN_LOCAL_STORAGE_ITEM_NAME);
		queryClient.clear();
		navigate("/login");
	}

	return (
		<DropdownMenu>
			<div className={style.profile}>
				<DropdownMenuTrigger className={style.trigger}>
					<div className={style.imgHolder}>
						{user?.role === "admin" && (
							<div className={style.badge}></div>
						)}
						<img
							src={user?.safe_picture_url}
							alt={t("common:avatar.profile")}
						/>
					</div>

					<div className={style.userInfo}>
						<span>
							{user?.username.length > 18
								? user?.username.slice(0, 15) + "..."
								: user?.username}
						</span>
						<span>
							{user?.role === "admin"
								? t("common:plan.admin")
								: t(
										[
											"common:plan.free",
											"common:plan.premium",
										][Number(user?.is_subscribed)]
									)}
						</span>
					</div>
					<div className={style.arrow}>
						<Icon icon="fa-chevron-down" />
					</div>
				</DropdownMenuTrigger>
				<DropdownMenuContent
					align="middle"
					collisionPadding={20}
					className={style.content}
				>
					<DropdownMenuGroup className={style.group}>
						<DropdownMenuItem
							className={style.item}
							to={`/u/${user?.username}`}
						>
							<div className={style.itemUser}>
								<div className={style.profileImage}>
									<img
										src={user?.safe_picture_url}
										alt={t("common:avatar.user")}
									/>
								</div>
								<div className={style.profileInfo}>
									<div className={style.name}>
										{user?.firstName} {user?.lastName}
									</div>

									<div className={style.email}>
										{user?.email}
									</div>
								</div>
							</div>
						</DropdownMenuItem>
					</DropdownMenuGroup>
					<DropdownMenuGroup className={style.group}>
						<DropdownMenuItem
							className={style.item}
							to="/settings/"
						>
							<Icon icon="fa-cog" />
							<span>{t("common:nav.settings")}</span>
						</DropdownMenuItem>
						<DropdownMenuItem className={style.item} to="/support">
							<Icon icon="fa-question-circle" />
							<span>{t("common:nav.help")} </span>
						</DropdownMenuItem>
					</DropdownMenuGroup>
					<DropdownMenuGroup className={style.group}>
						<DropdownMenuItem
							className={style.item}
							onClick={logOut}
						>
							<Icon icon="fa-sign-out-alt" />
							<span>{t("common:nav.logout")}</span>
						</DropdownMenuItem>
					</DropdownMenuGroup>
				</DropdownMenuContent>
			</div>
		</DropdownMenu>
	);
}

export default ProfileDropdown;
